import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  input: null,
  error: null,
  id: null,
  updateManageInputResult: null
};

const route = "modules/manage/modals/createEditManageInput/redux/slice";

export const manageCreateEditManageInput = createAsyncThunk(
  "manage/createEditManageInput/createEditManageInput",
  async (payload, { rejectWithValue }) => {
    try {
      const mutation = `
              mutation (
                  ${payload.id ? "$id: Int!," : ""}
                  $title: String!,
                  $onLabel: String!,
                  $offLabel: String!
              ) {
                  data: ${payload.id ? "updateInputLabel" : "createInputLabel"} (
                      ${payload.id ? "id: $id," : ""}
                      title: $title,
                      onLabel: $onLabel,
                      offLabel: $offLabel
                  ) {
                      id
                  }
              }
          `;
      const response = await clientMutation(mutation, payload, endpoints.GRAPHQL_GENERAL_V2);
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageCreateEditManageInput");
      return rejectWithValue(exc);
    }
  }
);

const manageCreateEditManageInputRedux = createSlice({
  name: "manage/createEditManageInput",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalCreateEditManageInput(state, action) {
      state.open = true;
      state.input = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageCreateEditManageInput
    builder.addCase(manageCreateEditManageInput.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageCreateEditManageInput.fulfilled, (state, action) => {
      state.loading = false;
      state.updateManageInputResult = action.payload;
    });
    builder.addCase(manageCreateEditManageInput.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCreateEditManageInputRedux;

// Extract and export each action creator by name
export const { reset, openModalCreateEditManageInput } = actions;

// Export the reducer, either as a default or named export
export default reducer;
